/**
 * /c/:chapterSlug/m/groups (no :groupId) — picks the user's preferred
 * group (last-selected → default → first) and redirects to
 * /c/:chapterSlug/m/groups/:groupId where the per-group view lives.
 *
 * The "All groups" merged view was dropped; group selection now flows
 * exclusively through the sidebar.
 */

import { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router';
import { foldersApi } from '@/services/api';

const LEGACY_LAST_GROUP_ID_KEY = 'navarasam96.messages.lastGroupId';
const LAST_GROUP_IDS_KEY = 'navarasam96.messages.lastGroupIds';

export function MessagesPage() {
  const params = useParams<{ chapterSlug?: string }>();
  const slug = params.chapterSlug ?? '96';
  const [targetId, setTargetId] = useState<string | null>(null);
  const [empty, setEmpty] = useState(false);

  useEffect(() => {
    let cancelled = false;
    foldersApi.list().then((folders) => {
      if (cancelled) return;
      const groups = folders.flatMap((f) => f.groups ?? []);
      if (groups.length === 0) { setEmpty(true); return; }

      let pick: string | null = null;
      try {
        const raw = window.localStorage.getItem(LAST_GROUP_IDS_KEY);
        if (raw) {
          const arr = JSON.parse(raw);
          if (Array.isArray(arr) && arr.length === 1 && groups.some((g) => g.id === arr[0])) pick = arr[0];
        }
      } catch { /* ignore */ }
      if (!pick) {
        try {
          const legacy = window.localStorage.getItem(LEGACY_LAST_GROUP_ID_KEY);
          if (legacy && groups.some((g) => g.id === legacy)) pick = legacy;
        } catch { /* ignore */ }
      }
      if (!pick) {
        const def = groups.find((g) => g.isDefault) ?? groups[0]!;
        pick = def.id;
      }
      setTargetId(pick);
    }).catch(() => setEmpty(true));
    return () => { cancelled = true; };
  }, []);

  if (empty) {
    return (
      <div className="p-6 text-white/60">
        <p>No groups available for this chapter.</p>
      </div>
    );
  }
  if (!targetId) return <div className="p-6 text-white/60">Loading…</div>;
  return <Navigate to={`/c/${slug}/m/groups/${targetId}`} replace />;
}

export default MessagesPage;
